import React, {ReactNode} from "react";
import styles from "./SectionHeader.module.scss";


export default (
  {
    image, title, subtitle, content, beige
  }: {
    beige?: boolean
    image: string
    title: string
    subtitle?: string
    content: ReactNode
  }
) => {
  return <section className={`${beige && 'bg-beige'}`}>
    <div className={`container ${styles.container}`}>

      <div className={styles.imageWrapper}>
        <img width="100" src={image} alt=""/>
      </div>

      <div className={styles.content}>
        <h1>{title}</h1>
        {subtitle && <h2>{subtitle}</h2>}
        {content}
      </div>

    </div>
  </section>
}